/**
 * Starts the import of a waiting upload with the choices of its column check (POST .../uploads/{id}/start). The
 * import then runs in the background; useUploads follows it.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/common/Toast';
import { uploadService } from '@/services/upload.service';
import { uploadsKey } from '@/config/upload';
import { uploadErrorMessage } from '@/utils/upload';
import { UploadStartRequest } from '@/types/upload';

export function useStartImport(workspace: string) {
  const { addToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: UploadStartRequest }) => uploadService.start(workspace, id, request),
    onError: (error) => addToast(uploadErrorMessage(error), 'error'),
    // After an error too: if the upload was started elsewhere meanwhile, the list shows it.
    onSettled: () => queryClient.invalidateQueries({ queryKey: uploadsKey(workspace) }),
  });
}
